import { render, staticRenderFns } from "./my-clubs.vue?vue&type=template&id=28782a85&scoped=true"
import script from "./my-clubs.vue?vue&type=script&lang=js"
export * from "./my-clubs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28782a85",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/subsapp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28782a85')) {
      api.createRecord('28782a85', component.options)
    } else {
      api.reload('28782a85', component.options)
    }
    module.hot.accept("./my-clubs.vue?vue&type=template&id=28782a85&scoped=true", function () {
      api.rerender('28782a85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/my-clubs/my-clubs.vue"
export default component.exports